import { ReactElement } from "react";
import { useSessionState } from "../../hooks/useSessionState";
import Navbar from "../nav/NavBar";
import NavControls from "../nav/NavControls";
import { navigate } from "vike/client/router";
import { usePageContext } from "vike-react/usePageContext";

export default function AuthenticatedRoute({
  children, hideNavBar
}: {
  children: ReactElement, hideNavBar? : boolean
}): ReactElement {
  const { urlPathname, urlParsed } = usePageContext();
  const { session } = useSessionState();

  if(session.isAuthenticating){
    return (<></>);
  }

  if (!session.isAuthenticated) {
    const queryString = new URLSearchParams(urlParsed.search).toString();
    const redirect = `${urlPathname}${queryString ? `?${queryString}` : ""}`;
    void navigate(`/signup?redirect=${encodeURIComponent(redirect)}`);
  }

  return (
    <>
      <Navbar navComponent={<NavControls/>} hidden={hideNavBar === undefined ? false : hideNavBar}/>
      {children}
    </>
  );
}